import Loadable from 'react-loadable'

const Profile = Loadable({
  loader: () => import(/* webpackChunkName: "profile" */ './components/Profile'),
  loading: () => null,
})
const Notifications = Loadable({
  loader: () => import(/* webpackChunkName: "profile" */ './components/Notifications'),
  loading: () => null,
})
const Favorite = Loadable({
  loader: () => import(/* webpackChunkName: "profile" */ './components/Favorite'),
  loading: () => null,
})
const Pasarmina = Loadable({
  loader: () => import(/* webpackChunkName: "profile" */ './components/Pasarmina'),
  loading: () => null,
})
const Eventmina = Loadable({
  loader: () => import(/* webpackChunkName: "profile" */ './components/Eventmina'),
  loading: () => null,
})
const Infomina = Loadable({
  loader: () => import(/* webpackChunkName: "profile" */ './components/Infomina'),
  loading: () => null,
})
const AddPasarmina = Loadable({
  loader: () => import(/* webpackChunkName: "addEventProfile" */ './components/AddPasarmina'),
  loading: () => null,
})
const AddEventmina = Loadable({
  loader: () => import(/* webpackChunkName: "addEventProfile" */ './components/AddEventmina'),
  loading: () => null,
})
const AddInfomina = Loadable({
  loader: () => import(/* webpackChunkName: "addEventProfile" */ './components/AddInfomina'),
  loading: () => null,
})
const Inbox = Loadable({
  loader: () => import(/* webpackChunkName: "profile" */ './components/Inbox'),
  loading: () => null,
})
const ChangePassword = Loadable({
  loader: () => import(/* webpackChunkName: "profile" */ './components/ChangePassword'),
  loading: () => null,
})

export {
  Profile,
  Notifications,
  Favorite,
  Pasarmina,
  AddPasarmina,
  AddEventmina,
  AddInfomina,
  Eventmina,
  Infomina,
  Inbox,
  ChangePassword,
}



// WEBPACK FOOTER //
// ./src/routes/Profile/index.js